import { CheckCircleFilled, InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Skeleton,
  Table,
  TableColumnsType,
  TableProps,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fabrics } from "../scripts/fabrics";
import IconLogout from "./icons/logout";

interface DataType {
  key: React.ReactNode;
  name: string;
  price?: number;
  seller?: string;
  unit?: number;
  url: string;
  date: string;
  status?: string;
}
type TableRowSelection<T extends object = object> =
  TableProps<T>["rowSelection"];

function randomDate(start: any, end: any) {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
}

const d = randomDate(new Date(2012, 0, 1), new Date());
console.log(d);

const data: DataType[] = [
  {
    key: 1,
    date: new Date().toLocaleString(),
    url: "1",
    unit: 100,
    price: 500,
    name: 'Вода "Поречская"',
    seller: "7",
    status: "done",
  },
  {
    key: 2,
    name: 'Вода "Родничок" артезианская негазированная бутилированная',
    date: new Date(new Date().getTime() - 11111111).toLocaleString(),
    url: "1",
    unit: 60,
    price: 300,
    seller: "6",
    status: "reject",
  },
  {
    key: 3,
    date: new Date(new Date().getTime() - 15555555).toLocaleString(),
    url: "1",
    unit: 200,
    price: 1200,
    name: 'Вода "Минеральная" артезианская негазированная бутилированная',
    seller: "7",
    status: "work",
  },
  {
    key: 4,
    date: new Date(new Date().getTime() - 88888888).toLocaleString(),
    url: "1",
    unit: 100,
    price: 700,
    name: 'Вода "Поречская"',
    seller: "6",
    status: "done",
  },
];

// rowSelection objects indicates the need for row selection
const rowSelection: TableRowSelection<DataType> = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};

const RequestsTable = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  const navigate = useNavigate();

  const columns: TableColumnsType<DataType> = [
    {
      title: "Номер",
      dataIndex: "key",
      key: "key",
      render: (key) => <>{<b>{key}</b>}</>,
    },
    {
      title: "Заказчик",
      dataIndex: "seller",
      key: "seller",
      render: (seller) => (
        <>
          {seller ? (
            <a onClick={() => navigate(`/factory/${seller}`)}>
              {fabrics[seller]?.title}
            </a>
          ) : (
            "Cборный заказ"
          )}
        </>
      ),
    },
    {
      title: "Дата запроса",
      dataIndex: "date",
      key: "date",
      render: (key) => <>{key.slice(0, 10)}</>,
    },
    { title: "Кол-во SKU", dataIndex: "unit", key: "unit" },
    { title: "Сумма", dataIndex: "price", key: "price" },
    {
      title: "Статус запроса",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <div className={status}>
          {status == "done" ? (
            "Выполнено"
          ) : status == "reject" ? (
            "Отказ"
          ) : (
            <div className="flex">
              <div>В обработке</div>
              <Tooltip
                color={"white"}
                title="Заказчик ожидает ответа более 5 дней"
              >
                <InfoCircleOutlined className="info" />
              </Tooltip>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Подробности",
      dataIndex: "url",
      key: "url",
      render: (url) => (
        <>
          {
            <a
              className="more-icon"
              onClick={() => navigate(`/search?type=${url}`)}
            >
              <IconLogout />
            </a>
          }
        </>
      ),
    },
  ];

  let location = window.location.pathname.includes("requ") ? undefined : false;

  return (
    <div className="white-block">
      {location != undefined && (
        <div className="flex-end">
          <div className="grey">
            <h1 className="">Последние входящие запросы</h1>
            <span>
              <CheckCircleFilled className="green" /> <b> 30 запросов</b>{" "}
              выполнено за последний месяц
            </span>
          </div>
          <div className="grid2">
            <Button onClick={() => navigate(`/requests`)}>Все заявки</Button>
            <Button>График заявок</Button>
          </div>
        </div>
      )}

      {!loading ? (
        <Table<DataType>
          columns={columns}
          dataSource={data}
          pagination={location}
        />
      ) : (
        <Skeleton active loading={loading} paragraph={{ rows: 5 }} />
      )}
    </div>
  );
};
export default RequestsTable;
